var AdapterSubscriptionStatus;
(function (AdapterSubscriptionStatus) {
  AdapterSubscriptionStatus[AdapterSubscriptionStatus["Subscribed"] = 0] = "Subscribed";
  AdapterSubscriptionStatus[AdapterSubscriptionStatus["Unsubscribed"] = 1] = "Unsubscribed";
})(AdapterSubscriptionStatus || (AdapterSubscriptionStatus = {}));
var AdapterConfigurationStatus;
(function (AdapterConfigurationStatus) {
  AdapterConfigurationStatus[AdapterConfigurationStatus["Unconfigured"] = 0] = "Unconfigured";
  AdapterConfigurationStatus[AdapterConfigurationStatus["Configuring"] = 1] = "Configuring";
  AdapterConfigurationStatus[AdapterConfigurationStatus["Configured"] = 2] = "Configured";
})(AdapterConfigurationStatus || (AdapterConfigurationStatus = {}));
var AdapterInitializationStatus;
(function (AdapterInitializationStatus) {
  AdapterInitializationStatus[AdapterInitializationStatus["Succeeded"] = 0] = "Succeeded";
  AdapterInitializationStatus[AdapterInitializationStatus["Failed"] = 1] = "Failed";
})(AdapterInitializationStatus || (AdapterInitializationStatus = {}));
var adapterIdentifiers = {
  launchdarkly: 'launchdarkly',
  localstorage: 'localstorage',
  memory: 'memory',
  splitio: 'splitio',
  graphql: 'graphql',
  http: 'http',
  combined: 'combined'
};
var cacheIdentifiers = {
  local: 'local',
  session: 'session'
};

export { AdapterConfigurationStatus, AdapterInitializationStatus, AdapterSubscriptionStatus, adapterIdentifiers, cacheIdentifiers };
